import React, { useContext } from 'react';
import HTML5Backend from 'react-dnd-html5-backend-cjs';
import { DndProvider, DndContext } from 'react-dnd-cjs';
const ShimDndProvider = DndProvider;
/**
 * This deals with the fact the react dnd doesn't let you have more than one global instance of itself
 * Works by checking if the context is set and if its is doesn't wrap children in the provider.
 *
 * Note: When nodejs supports ESM in CJS context we should be able to switch this to the latest version
 * of react dnd or we need to wait until we switch to ESM on backend
 */ const DndProviderWrapper = ({ children })=>{
    const dndContext = useContext(DndContext);
    if (!dndContext || !dndContext.dragDropManager) {
        return /*#__PURE__*/ React.createElement(ShimDndProvider, {
            backend: HTML5Backend
        }, children);
    }
    return children;
};
DndProviderWrapper.displayName = 'DndProviderWrapper';
export default DndProviderWrapper;

//# sourceMappingURL=DndProviderWrapper.js.map